/**
 * Extracted from snippets/product-badges.liquid (inline <script> at line 253).
 * No config bridge: the block contained no Liquid values at all, only
 * Liquid comments (kept below as // comments), which is why Phase 2 did not
 * pick it up. product-badges renders many times per page (every product card
 * as well as the PDP), so this block was emitted inline once per render; as
 * an asset the browser fetches it once and the existing
 * window.nsBadgeAccordionScrollBound guard still runs it once.
 */

(() => {
  if (window.nsBadgeAccordionScrollBound) return;
  window.nsBadgeAccordionScrollBound = true;

  // The card opens on a Motion One timeline (theme.js.liquid,
  // AccordionDisclosure._transition), NOT a CSS transition, so there is
  // no `transitionend` to wait on and the duration is not ours to
  // hard-code. Instead watch the card's own box until it stops moving:
  // that covers both its own expansion AND the sibling above it
  // collapsing, which is what would otherwise drag the target out from
  // under a scroll that started too early. Frame cap is the safety net.
  //
  const scrollWhenSettled = (element) => {
    let previous = null;
    let stableFrames = 0;
    let totalFrames = 0;

    const tick = () => {
      const rect = element.getBoundingClientRect();
      const current = rect.top + ':' + rect.height;

      if (current === previous) {
        stableFrames += 1;
      } else {
        stableFrames = 0;
        previous = current;
      }

      totalFrames += 1;

      if (stableFrames >= 3 || totalFrames > 60) {
        // `block: 'start'` lands under the sticky chrome on its own:
        // assets/theme.css sets `scroll-padding-block-start` on <html>
        // from `--sticky-area-height`, which scrollIntoView honours.
        //
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-badge-accordion-target]');
    if (!trigger) return;

    const slug = trigger.getAttribute('data-badge-accordion-target');
    if (!slug) return;

    const accordion = document.querySelector(
      'details.product-info__accordion[data-accordion-title="' + slug + '"]'
    );

    // No Shipping card on this PDP: bail out BEFORE preventDefault so the
    // browser follows the href exactly as it did before this handler
    // existed. Templates that carry the FAQ section still land on
    // `#faq-ship-date`; templates that carry neither behave the same way
    // the dead anchor always did. Returning early rather than guarding the
    // preventDefault is what keeps that path byte-for-byte unchanged.
    //
    if (!accordion) return;

    event.preventDefault();

    if (accordion.open) {
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    scrollWhenSettled(accordion);
    accordion.open = true;
  });
})();

